/* eslint-disable */
import React from 'react';
import '../asset/map.css';
import wave from '../asset/images/earthquake.png';

class Map extends React.Component {
  constructor() {
    super();
    this.state = {
      markers: []
    }
  }
  
  componentDidMount() {
    let location = {
      lat: 0,
      lng: 0,
    };
    this.map = new google.maps.Map(this.refs.map, {
      center: location,
      zoom: 2,
      mapTypeId: 'terrain',
      minZoom: 2,
    });
    this.addMarkers(this.props.data);
  }

  componentWillReceiveProps(nextProps) {
    let lastLocation = this.props.userLocation && this.props.userLocation.lat ? this.props.userLocation.lat : 'noLat';
    if (nextProps.userLocation && nextProps.userLocation.lat && nextProps.userLocation.lat !== lastLocation) {
    let _this = this;
    this.state.markers && this.state.markers[0] && this.state.markers[0].setMap(null);
    // let marker = new google.maps.Marker({
    //   position: nextProps.userLocation,
    //   label: 'me',
    //   map: this.map,
    // });
    // let infowindow = new google.maps.InfoWindow({
    //   content: 'my location'
    // });
    // marker.addListener('click', function() {
    //   infowindow.open(this.map, marker);
    // });
    // this.setState({
    //   ...this.state,
    //   markers: [marker, ...this.state.markers]
    // })
    this.map.setCenter(nextProps.userLocation);
    this.map.setZoom(14);
    // south latitude, west longitude, north latitude, east longitude
    let halfLength = 0.025;
    let boundaries = {
      south: nextProps.userLocation.lat - halfLength,
      west: nextProps.userLocation.lng - halfLength,
      north: nextProps.userLocation.lat + halfLength,
      east: nextProps.userLocation.lng + halfLength,
    }
    let bounds = `${boundaries.south},${boundaries.west},${boundaries.north},${boundaries.east}`
    let rows = 32;
    let cols = 32;
    let key = 'ApwPL2NmhEZCe7ezmrT3Ykz-0xukwYK-DQCrCzQnGKmHyDSOjjSkXInT5h8KJrSn';
    fetch(`https://dev.virtualearth.net/REST/v1/Elevation/Bounds?bounds=${bounds}&rows=${rows}&cols=${cols}&heights=sealevel&key=${key}`)
    .then((response) => {
      return response.json()
    })
    .then((body) => {
      let elevations = body.resourceSets[0].resources[0].elevations.map((elevation, i) => {
        let position = { 
          lat: nextProps.userLocation.lat - halfLength + ((halfLength*2)/cols*(Math.floor(i/cols))),
          lng: nextProps.userLocation.lng - halfLength + ((halfLength*2)/rows*(i%rows)),
        }
        return {
          elevation : elevation,
          position : position,
        }
      });
      
      let highPoint = elevations.sort((a,b) => b.elevation - a.elevation )[0];

      let directionsDisplay = new google.maps.DirectionsRenderer();
      directionsDisplay.setMap(_this.map);

      let directionsService = new google.maps.DirectionsService();
      let request = {
        origin: nextProps.userLocation,
        destination: highPoint.position,
        travelMode: 'DRIVING',
      };
      directionsService.route(request, function(result, status) {
        console.log(result);
        if (status == 'OK') {
          directionsDisplay.setDirections(result);
        }
      });
      this.setState({
        ...this.state,
        elevation: highPoint.elevation,
        directionsLink: `https://www.google.com/maps/dir/?api=1&origin=${nextProps.userLocation.lat},${nextProps.userLocation.lng}&destination=${highPoint.position.lat},${highPoint.position.lng}`
      })
      

    })
    .catch((err) => {
      console.log(err);
    });
    }
  }

  addMarkers(data) {
    for (let i = 0; i < data.features.length; i++) {

    let coords = data.features[i].geometry.coordinates;
    let latLng = new google.maps.LatLng(coords[1],coords[0]);
    let marker = new google.maps.Marker({
      position: latLng,
      map: this.map,
      icon: wave
    });
    let infowindow = new google.maps.InfoWindow({
      content: data.features[i].properties.place + data.features[i].properties.mag
    });
    let hello = () => {
      return function() {
        infowindow.open(this.map, marker);
      }
    }
    marker.addListener('click', hello());
    }
  }
  
  render() {

    const mapStyle = {
      width: '100%',
      height: 500,
      
    };
    
    return (
      <div>
        <div ref="map" className="map">I should be a map!</div>
        { this.state.directionsLink ?
        <div>
        {this.state.elevation ? <h3>To {this.state.elevation}m above sea level</h3> : null }
        <a href={`${this.state.directionsLink}&travelmode=DRIVING`} target="_blank"><h4>by Car</h4></a>
        <a href={`${this.state.directionsLink}&travelmode=WALKING`} target="_blank"><h4>on Foot</h4></a>
        <a href={`${this.state.directionsLink}&travelmode=BICYCLING`} target="_blank"><h4>bicycling</h4></a>
        <a href={`${this.state.directionsLink}&travelmode=TRANSIT`} target="_blank"><h4>transit</h4></a>
        </div>
        : null}
      </div>
    );
  }
}

export default Map;


// WEBPACK FOOTER //
// ./src/components/Map.js